export default "__VITE_ASSET__BuXtcczj__"